module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.usePlaceholder) ? _c('div', {
    staticClass: "flex justify-center"
  }, [_c('img', {
    staticClass: "w-3/4",
    attrs: {
      "src": "/static/cloud_empty.png",
      "alt": "No Words in Word Cloud"
    }
  })]) : _c('div', {
    staticClass: "flex justify-center"
  }, [_c('VueWordCloud', {
    staticStyle: {
      "width": "90%",
      "height": "500px",
      "margin": "0"
    },
    attrs: {
      "spacing": 0.2,
      "words": _vm.wordCloudData,
      "color": function (ref) {
          var sent = ref[2];

          return sent === 'blu' ? '#72CCD7' : sent === 'red' ? '#EB2D7C' : '#273248';
  },
      "font-family": "Helvetica",
      "font-weight": "Bold"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var text = ref.text;
        var weight = ref.weight;

        return [_c('div', {
          staticClass: "cursor-pointer",
          attrs: {
            "title": weight
          },
          on: {
            "click": function($event) {
              return _vm.onWordClick(text)
            }
          }
        }, [_vm._v("\n          " + _vm._s(text) + "\n        ")])]
      }
    }])
  })], 1), _vm._v(" "), (_vm.isModalOpen === true && _vm.selectedWord !== null) ? _c('pl-dialog', {
    attrs: {
      "title": _vm.selectedWord.word + ' (' + _vm.selectedWordData.sentences.length + ')',
      "size": 'lg',
      "disableOutsideClick": true
    },
    on: {
      "close": function($event) {
        return _vm.closeModal()
      }
    }
  }, [_c('div', {
    staticClass: "p-7 overflow-y-auto w-full"
  }, _vm._l((_vm.sentencesByUser), function(sentences, index) {
    return _c('div', {
      key: index,
      staticClass: "border px-6 py-6 rounded mb-5"
    }, [_c('div', {
      staticClass: "flex items-center mb-3"
    }, [_c('img', {
      staticClass: "inline-block h-9 w-9 rounded-full mr-2 ring-2 ring-white",
      attrs: {
        "src": _vm.getUserAvatar(index),
        "alt": "Avatar"
      }
    }), _vm._v(" "), _c('h5', {
      staticClass: "text-base font-semibold"
    }, [_vm._v("\n            " + _vm._s(_vm.getUserName(index)) + "\n          ")])]), _vm._v(" "), _c('div', {
      staticClass: "px-6 py-6 rounded mb-5"
    }, _vm._l((sentences), function(sent, index) {
      return _c('div', {
        key: index
      }, [_c('div', {
        staticClass: "mb-5",
        domProps: {
          "innerHTML": _vm._s(_vm.getSentence(sent.sentence))
        }
      }), _vm._v(" "), (index < sentences.length - 1) ? _c('div', [_vm._v("...")]) : _vm._e()])
    }), 0), _vm._v(" "), _c('div', {
      staticClass: "flex justify-start"
    }, [_c('button', {
      staticClass: "bg-primary text-white px-5 py-3 rounded",
      on: {
        "click": function($event) {
          return _vm.openSubmission(index)
        }
      }
    }, [_vm._v("\n            See in Context\n          ")])])])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.see_in_context_modal) ? _c('pl-dialog', {
    attrs: {
      "title": 'In Context - ' + _vm.selectedWord.word,
      "size": 'lg',
      "disableOutsideClick": true
    },
    on: {
      "close": function($event) {
        _vm.see_in_context_modal = false
      }
    }
  }, [_c('body', {
    staticClass: "flex w-full flex-col overflow-y overflow-x-hidden h-full mb-12"
  }, [_c('div', {
    staticClass: "flex items-center mt-5"
  }, [_c('SubmissionCard', {
    key: _vm.submissionToOpen.id,
    staticClass: "w-full px-12",
    attrs: {
      "submission": _vm.submissionToOpen,
      "selectedWordData": _vm.selectedWordData,
      "studentActivitySummary": true,
      "isInSummary": true,
      "isPlagPanel": _vm.is_anonymous_submission,
      "isAnonForPlagPanel": _vm.is_anonymous_submission,
      "showVerticalDotMenu": false
    }
  })], 1)]), _vm._v(" "), _c('footer', {
    staticClass: "px-7 py-4"
  }, [_c('div', {
    staticClass: "flex items-center justify-between w-full"
  }, [_c('div', {
    staticClass: "text-sm"
  }, [_c('button', {
    staticClass: "mx-5 px-8 py-2 w-24 bg-gray-100 hover:bg-gray-200 rounded cursor-pointer text-gray-400 :hover:text-gray-500 font-semibold disabled:opacity-50",
    on: {
      "click": function($event) {
        _vm.see_in_context_modal = false
      }
    }
  }, [_vm._v("\n            Back\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "text-sm"
  }, [_c('button', {
    staticClass: "px-8 py-2 bg-primary rounded cursor-pointer text-white font-semibold disabled:opacity-50",
    on: {
      "click": _vm.seeFullConversation
    }
  }, [_vm._v("\n            See full conversation\n          ")])])])])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-728956b3!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/onlineRoundtables/components/summaryComponents/KeyWordCloud.vue
// module id = 1139
// module chunks = 61